import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { RegisterComponent } from '../register/register.component';
import { ForgotMyPasswordComponent } from '../esqueci-minha-senha/forgot-my-password.component';
import { environment } from 'src/environments/environment';

type AcessoTab = 'login' | 'register' | 'forgot';

@Component({
  selector: 'app-acesso-shell',
  standalone: true,
  // Sem OnPush: este shell renderiza login/register/forgot (todos ChangeDetection.Default)
  // como filhos diretos. Esses filhos mutam estado de forma imperativa após HTTP
  // (isSendingSms, errorMessage, etc.); com o pai OnPush, o tick() pulava a subtree e a
  // view congelava (spinner eterno, erro invisível) nos caminhos que não navegam.
  imports: [CommonModule, RouterModule, LoginComponent, RegisterComponent, ForgotMyPasswordComponent],
  templateUrl: './acesso-shell.component.html',
  styleUrls: ['./acesso-shell.component.scss'],
})
export class AcessoShellComponent implements OnInit {
  public activeTab: AcessoTab = 'login';
  public readonly portalUrl = environment.portalUrl;
  public readonly heroImageUrl = 'https://storage.googleapis.com/smart-app-internal-banners/auth-hero.png?v=5';
  public readonly heroImageUrlWebp = 'https://storage.googleapis.com/smart-app-internal-banners/auth-hero.webp?v=5';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    const initialTab = (this.route.snapshot.data?.['tab'] as AcessoTab) ?? 'login';
    this.activeTab = initialTab;

    this.route.data.subscribe(data => {
      const tab = (data?.['tab'] as AcessoTab) ?? 'login';
      if (tab !== this.activeTab) this.activeTab = tab;
    });
  }

  selectTab(tab: AcessoTab): void {
    if (tab === this.activeTab) return;
    this.activeTab = tab;
    let path: string;
    switch (tab) {
      case 'register': path = '/auth/register'; break;
      case 'forgot': path = '/auth/forgot-my-password'; break;
      default: path = '/auth/login';
    }
    this.router.navigate([path], {
      queryParamsHandling: 'preserve',
      replaceUrl: true,
    });
  }
}
